import { getAuth } from 'firebase/auth';

const API_BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || 'https://dev.app.1eye.ai';

const fetchWithAuth = async (url: string, options?: RequestInit): Promise<Response> => {
  const auth = getAuth();
  const idToken = await auth.currentUser?.getIdToken();

  let finalUrl = url;
  if (url.startsWith('/api')) {
    finalUrl = url.replace('/api', API_BASE_URL);
  } else if (url.startsWith('/internal')) {
    finalUrl = `${API_BASE_URL}${url}`;
  }

  try {
    const response = await fetch(finalUrl, {
      ...options,
      headers: { ...(options?.headers || {}), Authorization: `Bearer ${idToken}` },
    });
    if (response.status >= 200 && response.status < 300) {
      return response;
    }
    const responseText = await response.text();
    let error: unknown = responseText;
    try {
      error = responseText ? JSON.parse(responseText) : response.statusText;
    } catch {
      error = responseText || response.statusText;
    }
    if (typeof error === 'string') {
      throw new Error(error);
    } else if (typeof error === 'object' && error !== null && 'error' in error) {
      if (typeof error.error === 'string') {
        // Add more context to the error message
        const errorMessage = error.error.includes('Failed to fetch')
          ? `${error.error}. Please check your network connection and backend service status.`
          : error.error;
        throw new Error(errorMessage, {
          cause: error,
        });
      } else if (
        typeof error.error === 'object' &&
        error.error !== null &&
        'message' in error.error
      ) {
        console.log(error.error.message);
        throw new Error(String(error.error.message), {
          cause: error,
        });
      } else {
        throw new Error('Something went wrong', {
          cause: error,
        });
      }
    }
    throw new Error(response.statusText);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default fetchWithAuth;
